function Home () {
    return(
        <div class="bg-gray-100 flex justify-center">
            <img src="https://pyxis.nymag.com/v1/imgs/3bb/9b4/8f748b6965a5b318ef7d1dbf21cc43bc5f-31-good-one-vanessa-bayer-totinos.rsocial.w1200.jpg" alt="vanessa byer with plate of totinos" />
        </div>
    )
}

export default Home;